import React, { Fragment } from 'react';
import {
  NAVIGATION_MOBILE_LIST,
  NAVIGATION_SINGLE_ITEMS,
  NAVIGATION_ALT_LIST,
  QUICK_LIST,
} from './es/Footer.utils.js';
import Link from 'next/link';
import styles from 'Custom/Footer/Navigation.module.scss';
import Image from 'Nori/Image/index';
import ContainerXL from 'Nori/Container/ContainerXL';
import ItemBreakpoint from 'Custom/ItemBreakpoint/index';
import FooterDropdown from 'Custom/FooterDropdown/index';
import FooterHeader from 'Custom/FooterDropdown/FooterHeader';
import FooterLink from 'Custom/Footer/FooterLink.js';
import RichText from 'Custom/RichText/index';
import FooterList from './FooterList';
import BRAND_LOGO from 'Images/logos/main-logo.png';

const Navigation = ({ className = '' }) => {
  return (
    <div className={`${className} ${styles.wrapper} ${styles.alternative}`} data-qa-tag="footer-navigation-wrapper">
      <ContainerXL data-qa-tag="footer-navigation-container">
        <div className={`${styles.split} ${styles.altSplit}`} data-qa-tag="footer-navigation-split">
          <Link className={styles.logo} href="/es-us/" data-qa-tag="footer-navigation-logo">
            <Image
              src={BRAND_LOGO}
              width={BRAND_LOGO.width}
              height={BRAND_LOGO.height}
              layout="intrinsic"
              alt="NEXPLANON® (etonogestrel implant) 68 mg Radiopaque Logo"
              data-design-category="bottom_nav_vd"
              data-design-type="clickAction"
              data-design-action="Logo"
              data-design-label="Logotipo Nexplanon"
              data-design-nori_id="Bottom Nav"
              data-design-module_name="Bottom Nav"
              data-design-module_no="00"
              data-qa-tag="footer-navigation-logo-image"
            />
          </Link>
          <ItemBreakpoint
            breakpoint="lg"
            className={styles.breakpointContainer}
            data-qa-tag="footer-navigation-breakpoint"
          >
            {/* Desktop */}
            <div className={styles.desktopBlock} data-qa-tag="footer-navigation-desktop">
              <FooterList
                className={styles.altFooterList}
                {...NAVIGATION_ALT_LIST}
                data-qa-tag="footer-list-alt"
              />
            </div>

            {/* Mobile */}
            <div className={styles.mobileBlock} data-qa-tag="footer-navigation-mobile">
              <div className={styles.firstBlock} data-qa-tag="footer-navigation-first-block">
                <FooterDropdown allowMultiple={true} data-qa-tag="footer-dropdown">
                  {NAVIGATION_MOBILE_LIST.map((item, i) => (
                    <RichText key={`item-${i}`} data-qa-tag={`footer-richtext-item-${i}`}>
                      <FooterHeader data-qa-tag="footer-header">{item.title}</FooterHeader>
                      <ul className={styles.listSubitems} data-qa-tag="footer-list-subitems">
                        {item.links.map((item, i) => (
                          <Fragment key={`subitem-${i}`}>
                            <li data-qa-tag={`footer-list-item-${i}`}>
                              <FooterLink {...item} data-qa-tag={`footer-dropdown-link-${i}`} />
                            </li>
                          </Fragment>
                        ))}
                      </ul>
                    </RichText>
                  ))}
                </FooterDropdown>
                <ul className={styles.singleLinks} data-qa-tag="footer-single-links">
                  {NAVIGATION_SINGLE_ITEMS.map((item, i) => (
                    <Fragment key={`subitem-${i}`}>
                      <li data-qa-tag={`footer-single-link-item-${i}`}>
                        <FooterLink className={styles.singleLink} {...item} data-qa-tag="footer-single-link" />
                      </li>
                    </Fragment>
                  ))}
                </ul>
              </div>
              <div className={styles.quickLinks} data-qa-tag="footer-quick-links">
                <FooterList className={styles.noDecoration} {...QUICK_LIST} data-qa-tag="footer-list-quick" />
              </div>
            </div>
          </ItemBreakpoint>
        </div>
      </ContainerXL>
    </div>
  );
};

export default Navigation;
